/**
 * snackbar
 */

const snackbar = {
  namespaced: true,
  state: {
    isShow: false,
    message: null,
    color: 'info',
    showMultiple: false,
    multipleMessage: null,
    multipleColor: 'info',
    timeout: 4000
  },
  getters: {},
  actions: {
    showMultiInfo ({ commit }, { message, timeout = 4000 }) {
      commit('showMultiInfo', { message: message, timeout: timeout })
    },
    showMultiError ({ commit }, { message, timeout = 4000 }) {
      commit('showMultiError', { message: message, timeout: timeout })
    },
    showInfo ({ commit }, { message, timeout = 4000 }) {
      commit('showInfo', { message: message, timeout: timeout })
    },
    showError ({ commit }, { message, timeout = 4000 }) {
      commit('showError', { message: message, timeout: timeout })
    },
    multiHide ({ commit }) {
      commit('multiHide');
    },
    hide ({ commit }) {
      commit('hide')
    },
  },
  mutations: {
    showMultiInfo (state, { message, timeout }) {
      console.log("showMultiInfo", message)
      state.multipleMessage = message
      state.multipleColor = 'info'
      state.showMultiple = true
      state.timeout = timeout
    },
    showMultiError (state, { message, timeout }) {
      state.multipleMessage = message
      state.multipleColor = 'error'
      state.showMultiple = true
      state.timeout = timeout
    },
    showInfo (state, { message, timeout }) {
      state.isShow = true
      state.message = message
      state.color = 'info'
      state.timeout = timeout
    },
    showError (state, { message, timeout }) {
      state.isShow = true
      state.message = message
      state.color = 'error'
      state.timeout = timeout
    },
    multiHide (state) {
      state.showMultiple = false
      state.multipleMessage = null
      state.multipleColor = 'info'
    },
    hide (state) {
      state.isShow = false
      state.message = null
      state.color = 'info'
    }
  },
}

export default snackbar
 